import { Trip } from "../../DataStructures/Trip/Trip";
import { MatDialog, MatDialogRef } from "@angular/material";
import { NoMoreVehiclesDialogComponent } from "../../admin-dashboard/optimizer/no-more-vehicles-dialog/no-more-vehicles-dialog.component";
import { Suggestion } from "../VehicleSuggestion/Suggestion";
import { MainService } from "../../services/optimizer-service/optimizer.service";
import { InfodialogComponent } from '../Dialog/dialog/infodialog/infodialog.component'
import { SandboxDialogComponent } from "../../admin-dashboard/optimizer/sandbox-dialog/sandbox-dialog.component";
import { LoadingDialogComponent } from "./dialog/loading-dialog/loading-dialog.component";
import { LocationPickerDialogComponent } from "./dialog/location-picker-dialog/location-picker-dialog.component";
import { LocationData } from "../../shared/location-picker/location-picker.component";
import { LocationOptions } from "../../shared/location-picker/location-picker.component";
import { PromptDialogComponent, PromptOptions } from "./dialog/prompt-dialog/prompt-dialog.component";
import { WeekSearchResults, WeekSearchResultDialogComponent } from "../../admin-dashboard/optimizer/week-search-result-dialog/week-search-result-dialog.component";
import { CellEditorDialogComponent, CellEditorData } from "../../admin-dashboard/optimizer/cell-editor-dialog/cell-editor-dialog.component";
import { SelectUsersDialogComponent, SelectUsersOptions } from "./dialog/select-users-dialog/select-users-dialog.component";
import { CompanyLocation } from "../../DataStructures/CompanyLocation/CompanyLocation";
import { MapWindowDialogComponent, MapDialogData } from "../../admin-dashboard/optimizer/map-window-dialog/map-window-dialog.component";
import { CreateAdminDialogComponent } from "../../admin-dashboard/manage-users/create-admin-dialog/create-admin-dialog.component";
import { MarkerOptionsDialogComponent } from "../../admin-dashboard/optimizer/marker-options-dialog/marker-options-dialog.component";
import { Vehicle } from "../../DataStructures/Vehicle/Vehicle";
import { VehicleSizeDialogComponent } from "../../admin-dashboard/optimizer/vehicle-size-dialog/vehicle-size-dialog.component";
import { VehicleReservation } from "../../DataStructures/VehicleReservation/VehicleReservation";
import { DecisionDialogComponent } from "../../admin-dashboard/optimizer/decision-dialog/decision-dialog.component";
import { AdvancedSettingsDialogComponent } from "../../admin-dashboard/optimizer/advanced-settings-dialog/advanced-settings-dialog.component";
import { TripRatingDialogComponent } from "../../user-dashboard/trip-rating-dialog/trip-rating-dialog.component";
import { ViewRouteDialogComponent } from "../../user-dashboard/view-route-dialog/view-route-dialog.component";
import { PassengerMapScreenComponent } from "../../shared/passenger-map-screen/passenger-map-screen.component";
import { ManageTravelEventDialogComponent } from "../../user-dashboard/dialogs/manage-travel-event-dialog/manage-travel-event-dialog.component";
import { TimeSlotForDay } from "../../DataStructures/TimeSlotRow/TimeSlotRow";
import { TimeSlotEditorDialogComponent } from "../../admin-dashboard/optimizer/time-slot-editor-dialog/time-slot-editor-dialog.component";
import { TimeSlotTableComponent } from "../../admin-dashboard/optimizer/time-slot-table/time-slot-table.component";
import { CalendarOptionsDialogComponent } from "../../user-dashboard/dialogs/calendar-options-dialog/calendar-options-dialog.component";
import { DriverVehiclesDialogComponent } from "../../admin-dashboard/driver-vehicles-dialog/driver-vehicles-dialog.component";
import { DriverAccessDialogComponent } from "../../admin-dashboard/driver-access-dialog/driver-access-dialog.component";
import { AddPassengerComponent } from "../../admin-dashboard/add-passenger/add-passenger.component";
import { DestinationPickerComponent } from "../../admin-dashboard/destination-picker/destination-picker.component";
import { ChangeCostComponent } from "../../admin-dashboard/change-cost/change-cost.component";
import { ShareLinkDialogComponent } from "../../admin-dashboard/share-link-dialog/share-link-dialog.component";
import { DeliveryRatingDialogComponent } from "../../delivery-rating-dialog/delivery-rating-dialog.component";
import { AddStopsDialogComponent, PrefillData } from "../../shared/add-stops-dialog/add-stops-dialog.component";
import { EditCustomerComponent } from "../../admin-dashboard/edit-customer/edit-customer.component";
import { CreateCustomerComponent } from "../../admin-dashboard/create-customer/create-customer.component";
import { SetCustomerDiscountComponent } from "../../admin-dashboard/set-customer-discount/set-customer-discount.component";
import { NewCustomersDialogComponent } from "../../admin-dashboard/new-customers-dialog/new-customers-dialog.component";
import { SavedAddressComponent } from "../../admin-dashboard/saved-address/saved-address.component";
import { ViewSavedAddressComponent } from "../../admin-dashboard/view-saved-address/view-saved-address.component";
import { EditLocationDialogComponent } from "./dialog/edit-location-dialog/editLocationDialog.component";

export class QuickDialog {

    constructor(private dialog: MatDialog) {

    }

    public VehicleSizeDialog(trip: Trip, newSize) {
        return new Promise((resolve, reject) => {

            let dialogRef = this.dialog.open(VehicleSizeDialogComponent, {
                width: '400px',
                data: {
                    vehicle: trip.vehicleReservation.vehicle,
                    newSize: newSize
                }
            });

            dialogRef.afterClosed().subscribe(result => {
                resolve(result);
            });
        })
    }

    public NoMoreVehiclesAvailableDialog(
        suggestions: Array<Suggestion>,
        roundTripTime: number,
        tripNoVehiclesAvailableFor: Trip,
        tripToIncludeRemainingPassengersOn: Trip,
        tripWithVehicleToWaitOn: Trip,
        tripTimeForSecondOption: number): Promise<any> {

        return new Promise((resolve, reject) => {

            let dialogRef = this.dialog.open(NoMoreVehiclesDialogComponent, {
                width: '400px',
                data: {
                    tripNoVehiclesAvailableFor: tripNoVehiclesAvailableFor,
                    tripToIncludeRemainingPassengersOn: tripToIncludeRemainingPassengersOn,
                    tripWithVehicleToWaitOn: tripWithVehicleToWaitOn,
                    tripTimeForSecondOption: tripTimeForSecondOption,
                    suggestions: suggestions,
                    roundTripTime: roundTripTime,
                }
            });

            dialogRef.afterClosed().subscribe(result => {
                resolve(result);
            });
        })
    }


    public SandboxDialog() {
        return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(SandboxDialogComponent, {
                width: '1080px',
                data: {
                }
            });

            dialogRef.afterClosed().subscribe((result) => {
                resolve(result);
            })
        })
    }

    public driverAccessDialog(driver) {
        return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(DriverAccessDialogComponent, {
                minWidth: window.screen.width > 767 ? '50%' : (window.innerWidth) + 'px',
                height: window.screen.width > 767 ? '70%' : (window.innerHeight) + 'px',
                data: driver,
                panelClass: 'driver-access-dialog-panel'
            })

            dialogRef.afterClosed().subscribe((payload) => {
                resolve(payload);
            })
        });
    }

    public driverVehiclesDialog(driver) {
        return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(DriverVehiclesDialogComponent, {
                minWidth: '400px',
                maxWidth: '400px',
                minHeight: '500px',
                maxHeight: "500px",
                data: driver
            })

            dialogRef.afterClosed().subscribe((payload) => {
                resolve(payload);
            })
        });
    }

    public ViewRouteDialog() {
        return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(ViewRouteDialogComponent, {
                minWidth: '400px',
                maxWidth: '400px',
                minHeight: '500px',
                maxHeight: "500px",
                panelClass: 'view-route-dialog-container'
            })

            dialogRef.afterClosed().subscribe(() => {
                resolve(null);
            })
        });
    }

    public calendarOptionsDialog(info) {
        return new Promise(async (resolve, reject) => {
            let dialogRef = this.dialog.open(CalendarOptionsDialogComponent, {
                minWidth: '300px',
                maxWidth: '300px',
                minHeight: '300px',
                maxHeight: "300px",
                data: info
            })

            dialogRef.afterClosed().subscribe((data) => {
                resolve(data);
            })
        });
    }

    public passengerManageEventDialog(pickupinfo) {

        return new Promise(async (resolve, reject) => {
            let dialogRef = this.dialog.open(ManageTravelEventDialogComponent, {
                minWidth: '300px',
                maxWidth: '300px',
                minHeight: '250px',
                maxHeight: "250px",
                data: pickupinfo
            })

            dialogRef.afterClosed().subscribe((data) => {
                resolve(data);
            })
        });
    }


    public DeliveryRatingDialog(trip, readOnly = false, hideComment = false, showNumbers = false) {
        return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(DeliveryRatingDialogComponent, {
                minWidth: window.screen.width > 767 ? '50%' : (window.screen.width - 40) + 'px',
                data: {
                    trip: trip,
                    readOnly: readOnly,
                    hideComment: hideComment,
                    showNumbers: showNumbers,
                    tripid: readOnly ? null : trip.id
                },
                panelClass: 'delivery-rating-dialog-panel'
            })

            dialogRef.afterClosed().subscribe(() => {
                resolve(null);
            })
        });
    }


    public TripRatingDialog(userid, line) {
        return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(TripRatingDialogComponent, {
                minWidth: window.screen.width > 767 ? '50%' : (window.screen.width - 40) + 'px',
                data: {
                    userid: userid,
                    line: line
                },
                panelClass: 'trip-rating-dialog-panel'
                
            })

            dialogRef.afterClosed().subscribe(() => {
                resolve(null);
            })
        });
    }

    public InfoDialog(message: string, title: string, closemsg: string): Promise<any> {

        return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(InfodialogComponent, {
                width: '300px',
                data: {
                    msg: message,
                    title: title,
                    closemsg: closemsg
                }
            });

            dialogRef.afterClosed().subscribe(() => {
                resolve(null);
            })
        })
    }

    public passengerAddressDialog() {
        return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(PassengerMapScreenComponent, {
                width: window.screen.width + "px",
                height: window.screen.height + "px",
            });

            dialogRef.afterClosed().subscribe((choice) => {
                resolve(choice);
            })
        })
    }

    public DecisionDialog(decision: Decision, size: string = '300px'): Promise<any> {

        return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(DecisionDialogComponent, {
                width: size,
                data: decision
            });

            dialogRef.afterClosed().subscribe((choice) => {
                resolve(choice);
            })
        })
    }

    public WeekSearchResultDialog(result: WeekSearchResults): Promise<string> {

        return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(WeekSearchResultDialogComponent, {
                width: '720px',
                data: result
            });

            dialogRef.afterClosed().subscribe((data) => {
                resolve(data);
            })
        })
    }

    public TimeSlotEditorDialog(slotForDay: TimeSlotForDay, timeSlotTable: TimeSlotTableComponent, companyid, locationid, type) {
        return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(TimeSlotEditorDialogComponent, {
                width: (window.innerWidth * .40) + 'px',
                height: (window.innerHeight * .95) + "px",
                data: { slotForDay: slotForDay, timeSlotTable: timeSlotTable, companyid: companyid, locationid: locationid, pickupType: type }
            });
            dialogRef.afterClosed().subscribe((data) => {
                resolve(data);
            })
        })
    }

    public CellEditorDialog<Row, Col, Data>(data: CellEditorData<Row, Col, Data>): Promise<any> {

        return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(CellEditorDialogComponent, {
                width: '790px',
                data: data
            });

            dialogRef.afterClosed().subscribe((data) => {
                resolve(data);
            })
        })
    }

    public AdvancedSettings(data): Promise<any> {
        return new Promise((resolve, reject) => {

            let dialogRef = this.dialog.open(AdvancedSettingsDialogComponent, {
                width: '500px',
                data: data
            });

            dialogRef.afterClosed().subscribe((data) => {
                resolve(data);
            })

        });
    }

    public MarkerOptionsDialog(data): Promise<any> {
        return new Promise((resolve, reject) => {

            let dialogRef = this.dialog.open(MarkerOptionsDialogComponent, {
                width: '355px',
                data: data
            });

            dialogRef.afterClosed().subscribe((data) => {
                resolve(data);
            })

        });
    }

    public MapMarkerDialog(data: MapDialogData): Promise<any> {

        return new Promise((resolve, reject) => {

            let dialogRef = this.dialog.open(MapWindowDialogComponent, {
                width: '790px',
                data: data
            });

            dialogRef.afterClosed().subscribe((data) => {
                resolve(data);
            })

        });
    }

    public SelectUserDialog(data: SelectUsersOptions): Promise<Array<any>> {

        return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(SelectUsersDialogComponent, {
                width: '790px',
                data: data
            });

            dialogRef.afterClosed().subscribe((data) => {
                resolve(data);
            })
        })
    }

    public PromptDialog(options: PromptOptions): Promise<string> {

        return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(PromptDialogComponent, {
                width: '300px',
                data: options
            });

            dialogRef.afterClosed().subscribe((data) => {
                resolve(data);
            })
        })
    }

    public CreateAdminDialog(clientData: any = null) {

        return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(CreateAdminDialogComponent, {
                width: '300px',
                data: clientData
            });

            dialogRef.afterClosed().subscribe((data) => {
                resolve(data);
            })
        })
    }

    public LoadingDialog(message = "Loading...."): MatDialogRef<LoadingDialogComponent, any> {


        let dialogRef = this.dialog.open(LoadingDialogComponent, {
            panelClass: 'custom-dialog-container',
            width: '300px',
            minWidth: '300px',
            height: '150px',
            minHeight: '150px',
            data: {
                msg: message
            }
        });

        return dialogRef;
    }

    public changeCost(trip: Trip) {
        return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(ChangeCostComponent, {
                minWidth: window.screen.width > 767 ? '20%' : (window.screen.width - 40) + 'px',
                data: trip
            });
            dialogRef.afterClosed().subscribe(result => {
                resolve(result);
            });
        })
    }

    public selectDestination(trip: Trip) {
        return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(DestinationPickerComponent, {
                minWidth: window.screen.width > 767 ? '20%' : (window.screen.width - 40) + 'px',
                data: trip
            });
            dialogRef.afterClosed().subscribe(result => {
                resolve(result);
            });
        })
    }

    public ShareLinkDialog(trip: Trip) {
        return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(ShareLinkDialogComponent, {
                minWidth: window.screen.width > 767 ? '30%' : (window.screen.width) + 'px',
                height: window.screen.width > 767 ? '80%' : (window.screen.height) + 'px',
                data: trip
            });

            dialogRef.afterClosed().subscribe(result => {
                resolve(result);
            });
        })
    }

    public SavedAddressDialog(customer) {
        return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(SavedAddressComponent, {
                minWidth: window.screen.width > 767 ? '50%' : (window.innerWidth) + 'px',
                height: window.screen.width > 767 ? '70%' : (window.innerHeight) + 'px',
                data: customer
            });

            dialogRef.afterClosed().subscribe(result => {
                resolve(result);
            });
        })
    }

    public ViewAddressDialog(customer) {
        return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(ViewSavedAddressComponent, {
                minWidth: window.screen.width > 767 ? '50%' : (window.innerWidth) + 'px',
                height: window.screen.width > 767 ? '70%' : (window.innerHeight) + 'px',
                data: customer
            });

            dialogRef.afterClosed().subscribe(result => {
                resolve(result);
            });
        })
    }

    public AddStopsDialog(tripid, prefill: PrefillData = null) {
        return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(AddStopsDialogComponent, {
                minWidth: window.screen.width > 767 ? '50%' : (window.innerWidth) + 'px',
                height: window.screen.width > 767 ? '70%' : (window.innerHeight) + 'px',
                data: {
                    tripid: tripid,
                    addressRequired: true,
                    prefill: prefill
                }
            });

            dialogRef.afterClosed().subscribe(result => {
                resolve(result);
            });
        })
    }

    public editCustomer(customer) {
        return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(EditCustomerComponent, {
                minWidth: window.screen.width > 767 ? '50%' : (window.innerWidth) + 'px',
                height: window.screen.width > 767 ? '70%' : (window.innerHeight) + 'px',
                data: customer
            });
            dialogRef.afterClosed().subscribe(result => {
                resolve(result);
            });
        })
    }

    public createCustomer() {
        return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(CreateCustomerComponent, {
                minWidth: window.screen.width > 767 ? '50%' : (window.innerWidth) + 'px',
                height: window.screen.width > 767 ? '70%' : (window.innerHeight) + 'px',
                data: {}
            });
            dialogRef.afterClosed().subscribe(result => {
                resolve(result);
            });
        })
    }

    public newCustomersDialog(start, end) {
        return new Promise((resolve) => {
            let dialogRef = this.dialog.open(NewCustomersDialogComponent, {
                minWidth: window.screen.width > 767 ? '720px' : (window.innerWidth) + 'px',
                maxWidth: window.screen.width > 767 ? '90vw' : (window.innerWidth) + 'px',
                maxHeight: '85vh',
                data: { start, end }
            });
            dialogRef.afterClosed().subscribe(result => {
                resolve(result);
            });
        });
    }

    public setCustomerDiscount(customer): Promise<any> {
        return new Promise((resolve) => {
            let dialogRef = this.dialog.open(SetCustomerDiscountComponent, {
                minWidth: window.screen.width > 767 ? '480px' : (window.innerWidth) + 'px',
                maxWidth: window.screen.width > 767 ? '560px' : (window.innerWidth) + 'px',
                data: customer
            });
            dialogRef.afterClosed().subscribe(result => {
                resolve(result);
            });
        });
    }

    public EditPassengerDialog(tripid,payload: {
        name: string,
        phone: string,
        comments: string,
        fee: number,
        collection: number,
        locationdata:{
            address:string,
            lat:any,
            lng:any
        }
    },meta = {}) {
        return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(AddPassengerComponent, {
                width: window.screen.width > 767 ? '55%' : '100%',
                maxWidth: window.screen.width > 767 ? '700px' : '100%',
                height: window.screen.width > 767 ? '95%' : window.screen.height + 'px',
                data: {
                    edit: true,
                    tripid: tripid,
                    payload: payload,
                    meta: meta
                }
            });

            dialogRef.afterClosed().subscribe(result => {
                resolve(result);
            });
        })
    }

    public AddPassengerDialog(tripid, meta = {}) {
        return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(AddPassengerComponent, {
                width: window.screen.width > 767 ? '55%' : '100%',
                maxWidth: window.screen.width > 767 ? '700px' : '100%',
                height: window.screen.width > 767 ? '95%' : window.screen.height + 'px',
                data: {
                    edit: false,
                    tripid: tripid,
                    meta: meta
                }
            });

            dialogRef.afterClosed().subscribe(result => {
                resolve(result);
            });
        })
    }

    public LocationPickerDialog(options: LocationOptions): Promise<Array<LocationData>> {

        return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(LocationPickerDialogComponent, {
                width: '720px',
                data: {
                    locationOptions: options
                }
            });

            dialogRef.afterClosed().subscribe(result => {
                console.log("location data");
                console.log(result);
                resolve(result);
            });
        })
    }

    public EditLocationDialog(options:any) {
        return new Promise((resolve, reject) => {
            let dialogRef = this.dialog.open(EditLocationDialogComponent, {
                width: '720px',
                data: options
            });

            dialogRef.afterClosed().subscribe(result => {                
                resolve(result);
            });
        })
    }

}

export interface Decision {
    message: string,
    options: Array<Option>
}

export interface Option {
    code: string,
    message: string,
    icon?: string
}